package songwritersnotebook.app.billing

enum class SubscriptionTier {
    UNKNOWN,
    FREE,
    HOBBYIST, // One-Time Paid ($14.99)
    STUDIO    // Subscription ($4.99/mo)
}

enum class LoadingState {
    LOADING,
    SUCCESS,
    ERROR
}

data class ProductInfo(
    val productId: String, // mapped from productId
    val name: String,
    val description: String,
    val oneTimePurchaseOfferDetails: OneTimeOfferDetails? = null,
    val subscriptionOfferDetails: List<SubscriptionOfferDetails>? = null,
    val platformObject: Any? = null // Holds com.android.billingclient.api.ProductDetails on Android
)

data class OneTimeOfferDetails(val formattedPrice: String)

data class SubscriptionOfferDetails(
    val basePlanId: String,
    val offerToken: String,
    val pricingPhases: PricingPhases
)

data class PricingPhases(val pricingPhaseList: List<PricingPhase>)

data class PricingPhase(val priceAmountMicros: Long, val formattedPrice: String)

data class ProductDetailsState(
    val loadingState: LoadingState = LoadingState.LOADING,
    val productDetailsList: List<ProductInfo> = emptyList(),
    val errorMessage: String? = null
)
